import { ReactNode, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAdminLang } from "./i18n";

interface Crumb {
  title: string;
  to?: string;
}

interface PageHeaderProps {
  title: string;
  crumbs?: Crumb[];
  actions?: ReactNode;
}

/** Template "page-header-breadcrumb" block at the top of every admin page. Titles are Persian keys for t(). */
export default function PageHeader({ title, crumbs = [], actions }: PageHeaderProps) {
  const { t } = useAdminLang();

  useEffect(() => {
    document.title = `${t(title)} | ${t("پنل مدیریت")}`;
  }, [title, t]);

  return (
    <div className="d-flex align-items-center justify-content-between page-header-breadcrumb flex-wrap gap-2">
      <div>
        <ol className="breadcrumb mb-1">
          <li className="breadcrumb-item">
            <Link to="/admin">{t("پنل مدیریت")}</Link>
          </li>
          {crumbs.map((crumb) => (
            <li className="breadcrumb-item" key={crumb.title}>
              {crumb.to ? <Link to={crumb.to}>{t(crumb.title)}</Link> : t(crumb.title)}
            </li>
          ))}
          <li className="breadcrumb-item active" aria-current="page">{t(title)}</li>
        </ol>
        <h1 className="page-title fw-medium fs-18 mb-0">{t(title)}</h1>
      </div>
      {actions && <div className="d-flex align-items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
